// extracted by mini-css-extract-plugin
export default {"discount":"DiscountPercentage_discount__urWH1"};